import { createContext } from 'react';

const AppContext = createContext<{
  isUserLoggedIn: boolean;
  loginInformationId: number | null;
}>({
  isUserLoggedIn: false,
  loginInformationId: null,
});

export default AppContext;
